import { useStyles } from "./ClusterDashboard.styles";
import { Grid } from "@mui/material";
import { ClusterHMICard } from "../components/ClusterHMICard/ClusterHMICard.view";
import { DndContext, closestCenter, MouseSensor, TouchSensor, useSensor, useSensors } from "@dnd-kit/core";
import { SortableContext, rectSortingStrategy } from "@dnd-kit/sortable";
import { SortableClusterHMICard } from "../components/SortableClusterHMICard/SortableClusterHMICard.view";
import { ClusterDragDropContext } from "./context/ClusterDragDropContextProvider";
import { useContext } from "react";

export const ClusterDashboard = () => {
    const classes = useStyles();
    const { isDragModeActive, clusterHMIs, onDragEnd } = useContext(ClusterDragDropContext);
    const sensors = useSensors(useSensor(MouseSensor), useSensor(TouchSensor));

    return (
        <div className={classes.clusterContainer}>
            <Grid
                style={{
                    display: "grid",
                    gridTemplateRows: "repeat(2, 1fr)",
                    gridTemplateColumns:
                        clusterHMIs.length === 2
                            ? "repeat(2, 1fr)"
                            : `repeat(${Math.ceil(clusterHMIs.length / 2)}, 1fr)`,
                    gap: "16px",
                }}
                container
                className={classes.gridContainer}
            >
                {isDragModeActive ? (
                    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={onDragEnd}>
                        <SortableContext
                            items={clusterHMIs.map((hmi) => hmi.id.toString())}
                            strategy={rectSortingStrategy}
                        >
                            {clusterHMIs.map((clusterHMI, index) => (
                                <SortableClusterHMICard
                                    machineCenter={clusterHMI}
                                    clusterHMINumber={clusterHMIs.length}
                                    key={clusterHMI.id}
                                    index={index}
                                    id={clusterHMI.id.toString()}
                                />
                            ))}
                        </SortableContext>
                    </DndContext>
                ) : (
                    clusterHMIs.map((clusterHMI, index) => (
                        <ClusterHMICard
                            machineCenter={clusterHMI}
                            clusterHMINumber={clusterHMIs.length}
                            key={clusterHMI.id}
                            index={index}
                        />
                    ))
                )}
            </Grid>
        </div>
    );
};
